export const actionTypes = {
  SYNTHESIS_RESPONSE: 'SYNTHESIS_RESPONSE',
};

const addSynthesisResponse = ({
  requestId,
  audioLink,
  status,
  progress,
  processingAt,
  endedAt,
}) => ({
  type: actionTypes.SYNTHESIS_RESPONSE,
  requestId,
  audioLink,
  status,
  progress,
  processingAt,
  endedAt,
});

export { addSynthesisResponse };
